
import { Route } from "react-router-dom";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import ContractTypesPage from "@/pages/contract-types/ContractTypesPage";
import ContractTypeCreatePage from "@/pages/contract-types/ContractTypeCreatePage";
import ContractTypeEditPage from "@/pages/contract-types/ContractTypeEditPage";

export function ContractTypeRoutes() {
  return (
    <>
      <Route 
        path="/contract-types" 
        element={
          <ProtectedRoute>
            <ContractTypesPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/contract-types/new" 
        element={
          <ProtectedRoute>
            <ContractTypeCreatePage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/contract-types/:id" 
        element={
          <ProtectedRoute>
            <ContractTypeEditPage />
          </ProtectedRoute>
        } 
      />
    </>
  );
}
